import moment from 'moment';

// Utils
import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';

// Global Selectors
// HACK: disobeys folder structure rules
import {
    selectFirstDate
    // @ts-ignore
} from 'components/DatePagination/selectors';
// @ts-ignore
import { selectCurrentSeasonIsComplete } from 'services/currentSeasonId/selectors';

/**
 * Checks to see if the following conditions are met.
 * The user is not viewing a timesheet older than last week.
 * The user is not viewing an old season.
 */
const selectCurrentMyTimesheetIsEditable = createDeepEqualSelector(
    [selectFirstDate, selectCurrentSeasonIsComplete],
    (firstDateState: string, currentSeasonIsComplete): boolean => {
        // Prevent the user from editing entries when they are viewing previous seasons
        if (currentSeasonIsComplete) {
            return false;
        }

        // Assume that old entries can't be edited as pay run is already over.
        const cutOff = moment()
            .startOf('week')
            .subtract(7, 'day')
            .format('YYYY-MM-DD');
        if (firstDateState <= cutOff) {
            return false;
        }

        return true;
    }
);

export { selectCurrentMyTimesheetIsEditable };
